import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';
import StyleSheet from 'react-native-media-query';

import DropdownPopover from '../../Components/DropdownPopover';
import { DropdownPopoverDataItem } from '../../Components/DropdownPopover/types';
import ListItem from '../../Components/ListItem';
import Search from '../../Components/Search';
import constants from '../../Config/constants';
import themeStyle from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';
import { OrderTypes } from '../../RTK/api/types';

const HeaderReservations = ({
  onSearch,
  onTypeChange,
}: {
  onSearch: (s: string) => void;
  onTypeChange: (type: OrderTypes[]) => void;
}) => {
  const theme = useTheme();
  const [type, setType] = useState<DropdownPopoverDataItem>(
    constants.MY_RESERVATION_TYPE_FILTER[0],
  );

  const _onTypeChange = useCallback(
    (type: DropdownPopoverDataItem) => {
      setType(type);
      onTypeChange(type.value.split(','));
    },
    [onTypeChange],
  );

  return (
    <View dataSet={{ media: ids.wrapper }} style={styles.wrapper}>
      <View
        dataSet={{ media: ids.filterContainer }}
        style={[themeStyle.flexDirectionRow, styles.filterContainer]}
      >
        <View
          style={[
            styles.filterItemContainer,
            { borderColor: theme['text-hint-color'] },
          ]}
        >
          <DropdownPopover
            data={constants.MY_RESERVATION_TYPE_FILTER}
            selectionType="color"
            value={type}
            trigger={
              <ListItem
                contentContainerStyle={[
                  themeStyle.pageVerticalSpacingMedium,
                  themeStyle.pageHorizontalSpacingSmall,
                ]}
                leftIcon={{ name: 'calendar-outline' }}
                rightIcon={{ name: 'chevron-down' }}
                title={
                  <Text numberOfLines={1}>
                    {type.value ? type.label : 'All'}
                  </Text>
                }
              />
            }
            onSelect={_onTypeChange}
          />
        </View>
      </View>

      <View
        dataSet={{ media: ids.searchContainer }}
        style={[themeStyle.flex3, styles.searchContainer]}
      >
        <Search
          fill={theme['color-info-500']}
          inputStyle={styles.searchInput}
          placeholder="Find your reservations..."
          onSearch={onSearch}
        />
      </View>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  wrapper: {
    [`@media ${breakpoints.md}`]: themeStyle.flexDirectionRowCenter,
  },
  filterItemContainer: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRowCenterCenter,
    borderWidth: 1,
  },
  filterContainer: {
    ...themeStyle.flex1,
    ...themeStyle.spacingBottomMedium,
    [`@media ${breakpoints.md}`]: {
      marginBottom: 0,
    },
  },
  searchContainer: {
    [`@media ${breakpoints.md}`]: themeStyle.spacingLeftMedium,
  },
  searchInput: {
    borderRadius: 7,
  },
});

export default HeaderReservations;
